import type { ModeColor } from "@src/types/factory-dashboard";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(225, 199, 67)",
  background: "rgba(225, 199, 67, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(25, 175, 0)",
  background: "rgba(25, 175, 0, 0.1)",
};

export const modeMapping = {
  0: { label: "modules.machineOverviewContainer.mode.off", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: {
    label: "modules.machineOverviewContainer.mode.automatic",
    color: GREEN,
  },
};

export const machinesMarandoservice = [
  {
    sourceId: "91cb061c-7178-8178-8d2f-c8691e103d02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetDescription",
    },
    modeMapping,
  },
  {
    sourceId: "47f9745b-fa60-8a60-bfd6-9f568a546f02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetDescription",
    },
    modeMapping,
  },
];
